import { azguardIconBase64 } from "./azguardIcon"

const KnownAztecConnectors = [
    {
        id: 'azguard-wallet',
        name: 'Azguard',
        icon: azguardIconBase64
    },
]

export default KnownAztecConnectors